import SimpleStore from "./simple-store";

class CardStore extends SimpleStore {
  setDefaultState(content) {
    const state = {
      showMenu: false,
      activePage: 0,
      componentOverlay: {
        showing: false,
        componentData: null,
        showCloseButton: true,
        state: "{}",
        fscstate: {
          slide: 0,
          scrollLeft: 0,
          scrollTop: 0,
          pickerShown: false,
          pickerScrollTop: 0,
        },
        vtstate: {
          slide: 0,
          position: JSON.stringify({
            yaw: 0,
            pitch: 0,
            hfov: 100,
          }),
        },
      },
      pages: [],
    };
    for (const page of content.pages) {
      const pageState = {
        scrollPosition: 0,
        sections: [],
      };
      for (const section of page.sections) {
        pageState.sections.push({ state: "{}" });
      }
      state.pages.push(pageState);
    }
    this.setState(state);
  }
}

const cardStore = new CardStore();

export default cardStore;
